import React from "react";
import { useContext } from "react";
import NoteContext from "../context/notes/noteContext";

const NoteItem = (props) => { 
  const context = useContext(NoteContext);
  const { deleteNote } = context;

  const OnclickDelete = () => {
    deleteNote(note._id);
    props.showAlert("Note Deleted Successfully", "success");
  };

  const { note, updateNote } = props;
  const [isExpanded, setIsExpanded] = React.useState(false);

  const handleMouseEnter = () => {
    setIsExpanded(true);
  };

  const handleMouseLeave = () => {
    setIsExpanded(false);
  };

  const getIconClass = (tag) => {
    switch (tag) {
      case "Official":
        return "fa-solid fa-briefcase";
      case "Personal":
        return "fa-solid fa-user";
      case "Important":
        return "fa-regular fa-star";
      case "Fun":
        return "fa-solid fa-smile";
      default:
        return "fa-solid fa-sticky-note";
    }
  };

  return (
    <div>
      <style>
        {`
          body {
            overflow-y: scroll;
          }
        `}
      </style>
      <div className="mx- my-2">
        <div
          className="card"
          style={{
            transition: "height 0.5s ease, opacity 0.5s ease",
            height: isExpanded ? "400px" : "55px",
            overflow: isExpanded ? "auto" : "hidden",
            opacity: isExpanded ? 1 : 0.7,
            position: "relative",
            zIndex: isExpanded ? 1 : "auto",
          }}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <div className="card-body">
            <div className="card-title">
              <div className="d-flex align-items-center justify-content-between">
                <h2>
                  <u>{note.title}</u>
                </h2>
                <i className={getIconClass(note.tag)}></i>
              </div>
            </div>
            {isExpanded && <h5 className="card-text">{note.description}</h5>}
          </div>
          <h4>
            <div className="d-flex align-items-center">
              <i className="fa-solid fa-trash mx-3" onClick={OnclickDelete}></i>
              <i className="fa-regular fa-pen-to-square" onClick={() => {updateNote(note)}}></i>
            </div>
          </h4>
        </div>
      </div>
    </div>
  );
};

export default NoteItem;
